/**
 * Os parâmetros clínicos que a régua sabe classificar.
 *
 * São os sete de `02-alertas.md` §1. ⓘ **O relógio entrega cinco deles** — pressão,
 * frequência cardíaca, SpO₂, temperatura e sono (§1.2); glicemia e perda de peso
 * chegam por outra via.
 */
enum HealthParameterEnum {
  GLUCOSE = 'glucose',
  BLOOD_PRESSURE = 'blood_pressure',
  BLOOD_OXYGEN = 'blood_oxygen',
  RESTING_HEART_RATE = 'resting_heart_rate',
  WEIGHT_LOSS = 'weight_loss',
  SLEEP = 'sleep',
  BODY_TEMPERATURE = 'body_temperature',
}

export default HealthParameterEnum;
